export default __webpack_public_path__ + "static/media/Sumita Dhar.d0bb639b.JPG";